import { useState } from 'react'
import ProductConfiguration from '@/components/admin/ProductConfiguration'
import ProductConfig from '@/components/admin/ProductConfig'

export default function ProductsPage() {
  const [currentTab, setCurrentTab] = useState<'manage' | 'bulk-update'>('manage')

  return (
    <div className="space-y-4">
      <div className="flex flex-col space-y-2">
        <h1 className="text-2xl font-bold tracking-tight">Product Management</h1>
        <p className="text-muted-foreground">
          Manage product configurations and update product prices in Shopify.
        </p>
      </div>

      {/* Custom Tab Navigation */}
      <div className="border-b border-gray-200">
        <div className="flex space-x-2">
          <button
            className={`px-4 py-2 text-sm font-medium ${
              currentTab === 'manage' 
                ? 'border-b-2 border-blue-500 text-blue-600'
                : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
            onClick={() => setCurrentTab('manage')}
          >
            Manage Products
          </button>
          <button
            className={`px-4 py-2 text-sm font-medium ${
              currentTab === 'bulk-update'
                ? 'border-b-2 border-blue-500 text-blue-600'
                : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'
            }`}
            onClick={() => setCurrentTab('bulk-update')}
          >
            Bulk Price Update
          </button>
        </div>
      </div>

      {/* Tab Content */}
      <div className="pt-4">
        {currentTab === 'manage' && <ProductConfig />}
        {currentTab === 'bulk-update' && <ProductConfiguration />}
      </div>
    </div>
  )
}